import { fetchWrapper } from "@/helpers/fetch-wrapper";

const API_URL = process.env.VUE_APP_SERVER_URL;

export const getSlides = () => fetchWrapper.get(`${API_URL}/api/slideshows?populate=*`);